import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { makeStyles } from "@material-ui/styles";
import Home from "./Home"
import LoginView from "./Login"
import Useradmin from "./User"
import Createpost from "./Create"

const useStyles = makeStyles({
  navbar: {
    margin: "auto",
    width: "85%",textAlign: "center",
    marginTop: "0.6em"

  },
  navbar_link: {
    display: "inline",
    paddingRight: "1em",
    
  }
})
function App() {
  const styles = useStyles()
  return (
    <Router>
      <nav className={styles.navbar}>
        <h2 className={styles.navbar_link}><Link to="/">Home</Link></h2>
        <h2 className={styles.navbar_link}><Link to="/user">User</Link></h2>
        <h2 className={styles.navbar_link}><Link to="/create">Create</Link></h2>
      </nav>
        <Switch>
          <Route exact path="/" component={()=>Home()} />
          <Route path="/login" component={()=>LoginView()} />
          <Route path="/user" component={()=>Useradmin()} />
          <Route path="/create" component={()=>Createpost()} />
        </Switch>
    </Router>
  );
}

export default App;
